module.exports = __webpack_public_path__ + "static/media/hero-1.d56c859f.jpg";